import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ModalV2, ModalV2Title, ModalV2Content } from '@design-system-etat/dsfr-react';

const ModaleCgu = ({ fermerModale, modaleOuverte }) => {
    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog, modaleOuverte]);

    return (
        <>
            {modaleOuverte ? (
                <ModalV2
                    id="conditionGenerale"
                    idModalTitle="conditionGenerale-title"
                    size="lg"
                    onClose={fermerModale}
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="conditionGenerale-title">
                            Conditions générales d'utilisation
                        </ModalV2Title>

                        <div className="cgu-hauteur-modale">
                            <div style={{ textAlign: 'justify' }}>
                                <h2>Article 1 - Objet</h2>
                                <p>
                                    Les présentes Conditions Générales (ci-après les « CGU ») ont
                                    pour objet de définir les modalités et les conditions
                                    d'utilisation du compte personnel sécurisé du Système
                                    d'information sur les armes (SIA).
                                </p>
                                <h2>Article 2 - Définitions</h2>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>
                                        « Conditions Générales d'Utilisation » ou « CGU »
                                    </span>{' '}
                                    désignent les présentes conditions d'utilisation du compte
                                    personnel sécurisé et des services qui lui sont associés.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>
                                        « Données à caractère personnel »
                                    </span>{' '}
                                    désignent toute information se rapportant à une personne
                                    physique identifiée ou identifiable (ci-après dénommée «
                                    personne concernée ») ; est réputée être une « personne physique
                                    identifiable » une personne physique qui peut être identifiée,
                                    directement ou indirectement, notamment par référence à un
                                    identifiant, tel qu'un nom, un numéro d'identification, des
                                    données de localisation, un identifiant en ligne, ou à un ou
                                    plusieurs éléments spécifiques propres à son identité physique,
                                    physiologique, génétique, psychique, économique, culturelle ou
                                    sociale.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>« Traitement »</span>{' '}
                                    désigne toute opération ou tout ensemble d'opérations effectuées
                                    ou non à l'aide de procédés automatisés et appliquées à des
                                    données ou des ensembles de données à caractère personnel,
                                    telles que la collecte, l'enregistrement, l'organisation, la
                                    structuration, la conservation, l'adaptation ou la modification,
                                    l'extraction, la consultation, l'utilisation, la communication
                                    par transmission, la diffusion ou toute autre forme de mise à
                                    disposition, le rapprochement ou l'interconnexion, la
                                    limitation, l'effacement ou la destruction.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>« Fichier »</span> désigne
                                    tout ensemble structuré de données à caractère personnel
                                    accessible selon des critères déterminés, que cet ensemble soit
                                    centralisé, décentralisé ou réparti de manière fonctionnelle ou
                                    géographique.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>
                                        « Responsable du traitement »
                                    </span>{' '}
                                    désigne la personne physique ou morale, l'autorité publique, le
                                    service ou un autre organisme qui, seul ou conjointement avec
                                    d'autres, détermine les finalités et les moyens du traitement;
                                    lorsque les finalités et les moyens de ce traitement sont
                                    déterminés par le droit de l'Union ou le droit d'un État membre,
                                    le responsable du traitement peut être désigné ou les critères
                                    spécifiques applicables à sa désignation peuvent être prévus par
                                    le droit de l'Union ou par le droit d'un État membre.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>« Destinataire »</span>{' '}
                                    désigne la personne physique ou morale, l'autorité publique, le
                                    service ou tout autre organisme qui reçoit communication de
                                    données à caractère personnel, qu'il s'agisse ou non d'un tiers.
                                    Toutefois, les autorités publiques qui sont susceptibles de
                                    recevoir communication de données à caractère personnel dans le
                                    cadre d'une mission d'enquête particulière conformément au droit
                                    de l'Union ou au droit d'un État membre ne sont pas considérées
                                    comme des destinataires. Le traitement de ces données par les
                                    autorités publiques en question est conforme aux règles
                                    applicables en matière de protection des données en fonction des
                                    finalités du traitement.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>« Consentement »</span> de
                                    la personne concernée désigne toute manifestation de volonté,
                                    libre, spécifique, éclairée et univoque par laquelle la personne
                                    concernée accepte, par une déclaration ou par un acte positif
                                    clair, que des données à caractère personnel la concernant
                                    fassent l'objet d'un traitement.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>« Utilisateur »</span> du
                                    site (ci-après l'«utilisateur» ou les «utilisateurs») désigne
                                    toute personne qui a créé son compte personnel sécurisé et qui
                                    utilise les services associés du système d'information sur les
                                    armes après avoir accepté les conditions générales
                                    d'utilisation.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>« Services »</span>{' '}
                                    désignent l'ensemble des fonctionnalités mises à disposition de
                                    l'utilisateur par le SIA par l'intermédiaire du compte personnel
                                    sécurisé, dans leur version actuelle et future ainsi que toute
                                    évolution dont elles pourraient faire l'objet.
                                </p>
                                <p>
                                    <span style={{ fontWeight: 'bold' }}>« Site »</span> désigne le
                                    portail internet du SIA dont le contenu est accessible à partir
                                    de l'adresse suivante : https://sia.registres.interieur.gouv.fr.
                                </p>
                                <h2>
                                    Article 3 - Acceptation des conditions générales d'utilisation
                                </h2>
                                <p>
                                    L'utilisation du SIA de manière occasionnelle ou régulière par
                                    l'utilisateur est subordonnée à l'acceptation pleine et entière
                                    et au respect intégral des clauses, droits et obligations
                                    découlant des présentes CGU.
                                </p>
                                <p>
                                    Conformément aux dispositions de l'article L. 112-9 du code des
                                    relations entre le public et l'administration, les présentes
                                    conditions générales s'imposent à tout utilisateur usager du
                                    service.
                                </p>
                                <p>
                                    En effet, ces dispositions prévoient que lorsque
                                    l'administration met en place un ou plusieurs téléservices, elle
                                    rend accessibles leurs modalités d'utilisation, notamment les
                                    modes de communication possibles. Ces modalités s'imposent au
                                    public.
                                </p>
                                <p>
                                    De la même manière, lorsque l'administration a mis en place un
                                    téléservice réservé à l'accomplissement de certaines démarches
                                    administratives, une administration n'est régulièrement saisie
                                    par voie électronique que par l'usage de ce téléservice.
                                </p>
                                <p>
                                    L'utilisation du système d'information sur les armes est
                                    strictement réservée à l'utilisateur professionnel ou non tel
                                    que défini dans les présentes CGU. L'utilisateur est tenu de
                                    prendre connaissance des CGU afin d'accéder aux différents
                                    portails du Système d'information sur les armes.
                                </p>
                                <p>
                                    L'utilisation du système d'information sur les armes est
                                    strictement réservée à l'utilisateur professionnel ou non tel
                                    que défini dans les présentes CGU. L'utilisateur est tenu de
                                    prendre connaissance des CGU afin d'accéder aux différents
                                    portails du Système d'information sur les armes.
                                </p>
                                <h2>
                                    Article 4 - Modification des conditions générales d'utilisation
                                </h2>
                                <p>
                                    Dans ce cadre, le Service central des armes se réserve le droit,
                                    d'une part, de modifier ou de mettre à jour à tout moment les
                                    présentes CGU et sans accord préalable de l'utilisateur en
                                    fonction des modifications apportées au service, de l'évolution
                                    de la législation ou pour tout autre motif jugé nécessaire et,
                                    d'autre part, de résilier, sans préavis ni indemnité d'aucune
                                    sorte, tout compte personnel sécurisé faisant l'objet d'une
                                    utilisation illicite ou frauduleuse ou contraire aux présentes
                                    CGU.
                                </p>
                                <p>
                                    Le Service central des armes se réserve également la liberté de
                                    faire évoluer, de modifier ou de suspendre, sans préavis, les
                                    services fournis par les différents portails du SIA pour des
                                    raisons de maintenance ou pour tout autre motif jugé nécessaire.
                                    Une page d'information est alors affichée à l'usager lui
                                    mentionnant cette indisponibilité. L'indisponibilité du service
                                    ne donne droit à aucune indemnité.
                                </p>
                                <p>
                                    Le Service central des armes s'engage à prendre toutes les
                                    mesures nécessaires permettant de garantir la sécurité et la
                                    confidentialité des informations fournies par l'usager. Le
                                    Service central des armes s'engage à n'opérer aucune
                                    commercialisation des informations et documents transmis par
                                    l'usager au moyen du Système d'information sur les armes, et à
                                    ne pas les communiquer à des tiers, en dehors des cas prévus par
                                    la loi.
                                </p>
                                <p>
                                    Pour toute question relative au site et aux présentes CGU, vous
                                    pouvez contacter le Service central des armes en utilisant la
                                    rubrique « nous contacter » ou par courriel à l'adresse suivante
                                    : sca-sia@interieur.gouv.fr.
                                </p>
                                <h2>
                                    Article 5 - Confidentialité et protection des données à
                                    caractère personnel
                                </h2>
                                <h3>5.1 Cadre légal du Système d'information sur les armes</h3>
                                <p>
                                    Le Système d'information sur les armes est un site du Service
                                    central des armes du ministère de l'intérieur.
                                </p>
                                <p>
                                    Il a été créé par le décret n°2020-487 du 28 avril 2020 portant
                                    création d'un traitement automatisé de données à caractère
                                    personnel dénommé « système d'information sur les armes » pris
                                    après avis de la CNIL.
                                </p>
                                <p>
                                    Ces dispositions sont actuellement codifiées aux articles R.
                                    312-84 à R. 312-90 du code de la sécurité intérieure.
                                </p>
                                <p>
                                    Il a fait l'objet de la délibération de la CNIL suivante :
                                    délibération n° 2020-001 du 09 janvier 2020 portant avis sur un
                                    projet de décret portant création d'un traitement automatisé de
                                    données à caractère personnel dénommé « système d'information
                                    sur les armes ».
                                </p>
                                <h3>5.2 Le responsable du traitement</h3>
                                <p>
                                    Le chef du Service central des armes du ministère de l'intérieur
                                    est le responsable du traitement conformément à l'article R.
                                    312-84 du code de la sécurité intérieure. Cet article dispose
                                    que le ministre de l'intérieur (service central des armes) est
                                    autorisé à mettre en œuvre un traitement automatisé de données à
                                    caractère personnel dénommé « système d'information sur les
                                    armes » (SIA).
                                </p>
                                <h3>5.3 L'objet du traitement</h3>
                                <p>
                                    Le Système d'information sur les armes s'inscrit dans une
                                    stratégie de sécurité publique, de lutte contre la fraude et de
                                    modernisation de l'action de l'État. Le SIA a pour objectif de
                                    permettre la dématérialisation de l'ensemble des actions en
                                    rapport avec le traitement, la gestion, la détention pour les
                                    professionnels et les usagers, des armes légales en France pour
                                    le périmètre du ministère de l'intérieur (armes civiles).
                                    <br />
                                    Les informations recueillies auprès des usagers font l'objet
                                    d'un traitement informatique permettant d'identifier et de gérer
                                    les demandes et d'assurer la traçabilité des armes légales.
                                    <br />
                                    Le système a pour finalités de permettre :
                                </p>
                                <ul>
                                    <li>
                                        a) La traçabilité des armes à feu portatives des catégories
                                        A, B et C et de leurs éléments ;
                                    </li>
                                    <li>
                                        b) La gestion et le suivi des titres d'acquisition et de
                                        détention d'armes, de munitions et de leurs éléments des
                                        catégories A, B et C ;
                                    </li>
                                    <li>
                                        c) La gestion et le suivi des autorisations relatives à la
                                        fabrication, au commerce et à l'intermédiation des armes,
                                        des munitions et de leurs éléments des catégories A1, B, C
                                        et D ;
                                    </li>
                                    <li>
                                        d) La gestion et le suivi des autorisations de port et de
                                        transport d'armes et de munitions ;
                                    </li>
                                    <li>
                                        e) La gestion et le suivi des avis du ministre de
                                        l'intérieur au ministre chargé des douanes sur les demandes
                                        d'autorisation de flux transfrontaliers d'armes, de
                                        munitions et de leurs éléments des catégories A, B, C et D ;
                                    </li>
                                    <li>
                                        f) A l'usager de procéder par voie électronique, au moyen
                                        d'un compte individualisé, aux formalités relatives aux
                                        armes.
                                    </li>
                                </ul>
                                <h3>5.4 Finalité des traitements</h3>
                                <h4>5.4.1 Les finalités poursuivies par le SIA</h4>
                                <p>Ces finalités ont pour objet :</p>
                                <ul>
                                    <li>a) De favoriser le «Dites le nous une fois » ;</li>
                                    <li>b) De renforcer la fiabilité de ses données ;</li>
                                    <li>
                                        c) D'alimenter avec les seules informations nécessaires à la
                                        vérification des droits des usagers et des professionnels ;
                                    </li>
                                    <li>
                                        d) De communiquer des informations fiables aux destinataires
                                        et aux tiers autorisés ;
                                    </li>
                                    <li>
                                        e) Dassurer un contrôle continu exigé par le droit de
                                        l'Union européenne ;
                                    </li>
                                    <li>f) De réduire les délais de traitement des contrôles.</li>
                                </ul>

                                <h4>5.4.2 Les traitements et fichiers consultés par le SIA</h4>
                                <p>
                                    Le SIA peut procéder à la consultation automatique et, le cas
                                    échéant, simultanée des traitements de données à caractère
                                    personnel suivants :
                                </p>
                                <ul>
                                    <li>
                                        a) Le fichier national des interdits d'acquisition et de
                                        détention d'arme (FINIADA) ;
                                    </li>
                                    <li>b) Le casier judiciaire national automatisé ;</li>
                                    <li>
                                        c) Le fichier national de contrôle des titres d'identité ;
                                    </li>
                                    <li>d) Le traitement API entreprise ;</li>
                                    <li>e) La base des adresses nationales ;</li>
                                    <li>
                                        f) Les systèmes de traitement des fédérations des
                                        disciplines sportives utilisant des armes et de la
                                        fédération nationale de la chasse.
                                    </li>
                                </ul>

                                <h3>5.5 Les destinataires des données</h3>
                                <p>
                                    L'accès au fichier est limité aux personnes énumérées par
                                    l'article R. 312-86 du code de la sécurité intérieure
                                </p>
                                <p>
                                    Selon cet article, certaines personnes et autorités peuvent
                                    avoir accès à tout ou partie des données à caractère personnel
                                    et informations enregistrées dans le traitement prévu à
                                    l'article R. 312-84 du même code, à raison de leurs attributions
                                    et dans la limite du besoin d'en connaître.
                                </p>
                                <p>
                                    La consultation par ces personnes et autorités des données
                                    figurant dans le Système d'information sur les armes fait
                                    l'objet d'une traçabilité. En effet, selon l'article R. 312-89
                                    du code de la sécurité intérieure, les opérations de collecte,
                                    de modification, de consultation, de communication, de
                                    transfert, d'interconnexion et de suppression des données et
                                    informations du traitement font l'objet d'un enregistrement
                                    comprenant l'identification de l'auteur, la date, l'heure et la
                                    nature de l'opération. Ces informations sont conservées pendant
                                    six ans.
                                </p>

                                <h3>5.6 La durée de conservation des données</h3>
                                <p>
                                    Les durées de conservation des données à caractère personnel et
                                    informations recueillies par le système d'information sur les
                                    armes sont précisées par l'article R. 312-88 du code de la
                                    sécurité intérieure.
                                </p>
                                <p>
                                    Ce texte prévoit notamment que les données à caractère personnel
                                    et informations relatives aux armes et éléments d'armes sont
                                    conservées trente ans à compter de la destruction physique de
                                    ceux-ci. Ces données concernent l'identification des armes
                                    enregistrées, y compris leur transformation et modification, les
                                    noms, prénoms, date et lieu de naissance et adresse des
                                    fournisseurs, acquéreurs et détenteurs successifs, ainsi que les
                                    dates des opérations correspondantes.
                                </p>
                                <p>
                                    La « journalisation » des actes effectués dans le SIA est
                                    conservée pendant une durée de six ans.
                                </p>

                                <h3>5.7 Les droits des utilisateurs</h3>
                                <h4>5.7.1 Les droits</h4>
                                <p>
                                    a) Les droits d'information, d'accès, de rectification et à la
                                    limitation s'exercent directement via le compte de l'application
                                    ou auprès du Service central des armes ou du préfet
                                    territorialement compétent, en fonction de leurs attributions
                                    respectives.
                                </p>
                                <p>
                                    b) Les droits d'accès, de rectification et à la limitation des
                                    données peuvent faire l'objet de restrictions.
                                </p>
                                <p>
                                    c) Les droits de portabilité et d'opposition ne s'appliquent pas
                                    au présent traitement.
                                </p>

                                <h4>5.7.2 La mise en œuvre des droits</h4>
                                <p>
                                    L'usager peut exercer son droit d'accès par écrit, par courriel,
                                    ou par pli simple ou suivi ou recommandé avec avis de réception,
                                    accompagné d'une copie de sa pièce d'identité, ou éventuellement
                                    sur place en présentant une pièce d'identité.
                                </p>
                                <p>
                                    Toutefois, le responsable du traitement peut refuser la demande
                                    d'accès mais il doit dans ce cas, motiver sa décision et exposer
                                    les voies et délais de recours. Il peut aussi ne pas y répondre,
                                    si elle présente un caractère manifestement abusif notamment par
                                    le nombre ou la répétition. S'il ne dispose pas ou plus de
                                    données, le responsable du traitement doit néanmoins répondre
                                    dans un délai de deux mois. Enfin, le droit d'accès doit
                                    s'exercer dans le respect des droits des tiers.
                                </p>
                                <h4>5.7.3 L'exercice des droits </h4>
                                <p>
                                    Le correspondant délégué à la protection des données (CDPD) du
                                    Service central des armes est votre interlocuteur pour toute
                                    demande d'exercice de vos droits dans le cadre du Système
                                    d'information sur les armes.
                                </p>
                                <ul>
                                    <li>
                                        a) Contacter le correspondant délégué à la protection des
                                        données (CDPD) par voie électronique : <br />
                                        donnees-personnelles-sca@interieur.gouv.fr
                                    </li>
                                    <li>
                                        b) Contacter le correspondant délégué à la protection des
                                        données (CDPD) par courrier postal : Ministère de
                                        l'Intérieur
                                        <br />
                                        À l'attention du correspondant délégué à la protection des
                                        données (CDPD)
                                        <br />
                                        Place Beauvau
                                        <br />
                                        75008 Paris
                                    </li>
                                </ul>
                                <p>
                                    Dans ces deux cas, il est demandé à l'usager de joindre à sa
                                    demande la copie de sa carte nationale d'identité pour justifier
                                    de l'exercice de ses droits. L'usager est informé que sauf si
                                    une telle communication se révèle impossible ou exige des
                                    efforts disproportionnés, le responsable du traitement notifie à
                                    chaque destinataire auquel les données personnelles ont été
                                    communiquées, toute rectification ou effacement ou toute
                                    limitation de traitement
                                </p>
                                <h4>5.7.4 Les réclamations (plaintes) auprès de la CNIL</h4>
                                <p>
                                    Si vous estimez, après nous avoir contacté, que vos droits sur
                                    vos données ne sont pas respectés, vous pouvez adresser une
                                    réclamation (plainte) à la CNIL à l'adresse :
                                    https://www.cnil.fr/fr/plaintes.
                                </p>
                                <h2>Article 6 - Sécurité</h2>
                                <p>
                                    Les mesures de sécurité sont mises en œuvre conformément à la
                                    politique de sécurité des systèmes d'information (PSSI) du
                                    ministère de l'Intérieur, issue de la PSSI de l'État. Le
                                    téléservice a fait l'objet d'une décision d'homologation en date
                                    du 01/07/2020 au référentiel général de sécurité.
                                </p>
                                <p>
                                    Les données à caractère personnel et relatives au SIA sont
                                    stockées sur un service protégé du ministère de l'Intérieur. En
                                    cas de violation ou compromission des données personnelles
                                    détenues sur le SIA, une notification sera transmise dans les 72
                                    heures aux usagers concernés.
                                </p>
                                <p>
                                    La décision d'homologation atteste formellement auprès des
                                    utilisateurs que les applications accessibles par
                                    l'intermédiaire du système d'information sur les armes sont
                                    homologuées conformément aux prescriptions définies par le RGS
                                    (Référentiel Général de Sécurité).
                                </p>

                                <h2>Article 7 - Fraude et abus</h2>

                                <p>
                                    En utilisant les services associés au compte personnel sécurisé,
                                    l'utilisateur s'engage notamment :
                                </p>
                                <ul>
                                    <li>a) A à ne pas communiquer de fausses informations ;</li>
                                    <li>
                                        b) A ne pas utiliser l'identité d'un tiers dans le but
                                        d'obtenir illégalement et indûment un droit ou une
                                        prestation ;
                                    </li>
                                    <li>
                                        c) A ne pas utiliser l'identité d'un tiers en vue d'obtenir
                                        des renseignements relatifs à ce dernier.
                                    </li>
                                </ul>
                                <p>
                                    La loi rend passible d'une amende et d'une peine
                                    d'emprisonnement quiconque se rend coupable de fraude ou de
                                    fausse déclaration, d'escroquerie ou de tentative d'escroquerie
                                    conformément aux dispositions en vigueur.
                                </p>
                                <p>
                                    Le Service central des armes du ministère de l'intérieur se
                                    réserve le droit d'effectuer des contrôles à tout moment et, le
                                    cas échéant, d'entamer des poursuites pénales à l'encontre des
                                    contrevenants.
                                </p>
                                <h2>Article 8 - Responsabilités</h2>
                                <h3>8.1 Responsabilités de l'utilisateur</h3>
                                <p>
                                    Tout matériel et logiciel nécessaires à l'accès et à
                                    l'utilisation du compte personnel sécurisé restent exclusivement
                                    à la charge de l'utilisateur qui est donc seul responsable du
                                    bon fonctionnement de son équipement ainsi que de son accès à
                                    internet.
                                </p>
                                <p>
                                    Il lui appartient ainsi de prendre toutes mesures appropriées de
                                    façon à se prémunir contre les effets de la piraterie, notamment
                                    en adoptant une configuration informatique sécurisée et adaptée
                                    par la mise en place d'un logiciel de détection de virus
                                    régulièrement mis à jour.
                                </p>
                                <p>
                                    Il appartient à l'utilisateur de prendre toutes mesures
                                    nécessaires pour s'assurer que les caractéristiques techniques
                                    de son équipement lui permettent la consultation des données et
                                    l'utilisation des Services.
                                </p>
                                <p>
                                    L'utilisateur est seul responsable de l'utilisation qu'il fait
                                    de son compte personnel sécurisé, ainsi que des services du
                                    système d'information sur les armes qui lui sont associés.
                                    L'utilisateur est seul responsable des conséquences d'un accès à
                                    son compte personnel sécurisé qui ne serait pas conforme aux
                                    conditions générales d'utilisation.
                                </p>
                                <p>
                                    Il est également responsable de la confidentialité de ses
                                    identifiant et mot de passe. De façon générale, l'utilisateur
                                    est seul responsable de la communication de toute information
                                    jugée confidentielle. L'utilisateur est seul responsable de
                                    toutes les conséquences qui résulteraient d'une erreur de
                                    transmission ou de manipulation de sa part.
                                </p>
                                <p>
                                    L'utilisateur s'interdit toute action susceptible d'entraver ou
                                    de perturber le bon fonctionnement ou l'accessibilité technique
                                    du site.
                                </p>
                                <p>
                                    L'utilisateur s'engage à accéder au site en utilisant un
                                    matériel ne contenant pas de virus. Le Service central des armes
                                    ne garantit pas que ses serveurs soient exempts de virus et
                                    autres composants dangereux.
                                </p>
                                <p>
                                    Il appartient donc à l'utilisateur de prendre toutes les mesures
                                    appropriées pour protéger ses propres données et/ou logiciels de
                                    la contamination par d'éventuels virus circulant sur le réseau
                                    Internet.
                                </p>
                                <p>
                                    L'utilisateur s'engage à assurer, si nécessaire, la mise à jour
                                    des informations personnelles le concernant, lesquelles doivent
                                    avoir été données avec exactitude, et sous sa seule
                                    responsabilité.
                                </p>
                                <p>
                                    L'utilisateur s'engage à avertir le Service central des armes
                                    immédiatement :
                                </p>
                                <ul>
                                    <li>a) de toute utilisation non autorisée de vos données ;</li>
                                    <li>
                                        b) S'il constate qu'une des données affichées n'est pas
                                        correcte.
                                    </li>
                                </ul>
                                <p>
                                    Il est vivement conseillé de vous déconnecter à la fin de votre
                                    session a fortiori si vous utilisez un appareil public ou qui ne
                                    vous appartient pas.
                                </p>

                                <h3>
                                    8.2 Responsabilités du Service central des armes du ministère de
                                    l'intérieur
                                </h3>
                                <p>
                                    Le Service central des armes du ministère de l'intérieur met en
                                    œuvre tous les moyens raisonnables à sa disposition pour assurer
                                    un accès de qualité au compte personnel sécurisé.
                                </p>
                                <p>
                                    Le compte personnel sécurisé est accessible 24 heures sur 24, 7
                                    jours sur 7 sauf en cas de force majeure ou de survenance d'un
                                    évènement hors du contrôle du Service central des armes et sous
                                    réserve des éventuelles pannes et interventions de maintenance
                                    nécessaires au bon fonctionnement du compte personnel.
                                </p>
                                <p>
                                    Le Service central des armes du ministère de l'intérieur
                                    s'engage à mettre en œuvre les mesures de sécurité
                                    raisonnablement nécessaires pour assurer le fonctionnement des
                                    services et la confidentialité des informations communiquées.
                                </p>
                                <p>
                                    Le Service central des armes du ministère de l'intérieur ne
                                    peut, en aucun cas, être tenu responsable de tout
                                    dysfonctionnement du réseau et/ou des serveurs ou tout autre
                                    évènement échappant à son contrôle, qui empêcherait ou
                                    dégraderait l'accès au compte personnel sécurisé.
                                </p>
                                <p>
                                    Le Service central des armes du ministère de l'intérieur se
                                    réserve la possibilité d'interrompre, de suspendre momentanément
                                    ou de modifier sans préavis l'accès à tout ou partie du compte
                                    personnel sécurisé afin d'en assurer la maintenance, ou pour
                                    toute autre raison, sans que l'interruption n'ouvre droit à
                                    aucune obligation ni indemnisation.
                                </p>
                                <h2>Article 9 - Atteinte à la réputation, dénigrement</h2>
                                <p>
                                    Toute personne physique ou morale, usager ou non du site et/ou
                                    des services proposés par le SIA, qui par ses propos tenus
                                    oralement, par vidéo ou par écrit, ou par n'importe quel autre
                                    moyen, sur quelques supports ou par quelque procédé que ce soit,
                                    y compris sur des réseaux sociaux ou sur des forums ouverts ou
                                    fermés, et/ou qui aurait un comportement, direct ou indirect, de
                                    nature à porter atteinte à l'image et/ou à la réputation du site
                                    « SIA », que ces propos ou comportements soient tenus en public
                                    ou en réseau(x) privé(s) néanmoins accessible(s) à des tiers du
                                    fait de sa diffusion, même involontaire ou indirecte par un
                                    membre du réseau, pourra faire l'objet de poursuites
                                    individuelles ou collectivement avec d'autres, y compris sur le
                                    plan judiciaire, devant toute juridiction compétente, aux fins
                                    de voir supprimer toute atteinte, et réparer le dommage causé,
                                    qu'il soit moral ou financier.
                                </p>
                                <h2>Article 10 - Propriété intellectuelle</h2>
                                <p>
                                    Le Service central des armes du ministère de l'intérieur est
                                    titulaire des droits de propriété intellectuelle ou détient les
                                    droits nécessaires sur l'ensemble des éléments constituant le
                                    système d'information sur les armes, tels que, notamment, les
                                    développements informatiques et logiciels, les bases de données,
                                    les documentations, éléments visuels ou sonores, graphismes,
                                    marques et logos.
                                </p>
                                <p>
                                    Toute représentation ou reproduction totale ou partielle des
                                    logos, marques, signes distinctifs ou bases de données du
                                    Service central des armes, sans l'autorisation préalable et
                                    expresse de ce dernier est interdite.
                                </p>
                                <p>
                                    Le Service central des armes concède un droit d'accès et
                                    d'utilisation des services proposés par le système d'information
                                    sur les armes à titre non-exclusif et non transférable pour les
                                    stricts besoins de l'utilisateur.
                                </p>
                                <p>
                                    Ce droit comprend le droit de reproduire les contenus pour
                                    stockage sur écran et de reproduction pour tirage papier. Toute
                                    mise en réseau, toute rediffusion, sous quelque forme que ce
                                    soit, est interdite. Par ailleurs, ce droit est réservé à
                                    l'usage exclusif de l'utilisateur et n'est pas transmissible.
                                </p>
                                <p>
                                    A cet égard, l'utilisateur s'engage à respecter les conditions
                                    générales d'utilisation et à n'entreprendre aucun acte de nature
                                    à porter atteinte aux droits de propriété intellectuelle du
                                    Service central des armes ou de tiers. Sauf autorisation
                                    expresse et préalable du Service central des armes, sont
                                    interdites, toute adaptation, mise à disposition du public,
                                    distribution ou rediffusion, sous quelque forme que ce soit, de
                                    tout ou partie des éléments du Site, notamment les contenus et
                                    codes informatiques, protégés ou susceptibles de protection par
                                    le droit de la propriété intellectuelle.
                                </p>

                                <h2>Article 11 - Accessibilité</h2>
                                <p>
                                    Le Service central des armes ainsi que la Direction du numérique
                                    s'efforcent de permettre que les usagers puissent avoir accès en
                                    continue aux divers portails du système d'information sur les
                                    armes. Néanmoins, le Service central des armes se réserve le
                                    droit de ne pouvoir garantir l'accessibilité à son site internet
                                    et à l'ensemble des téléservices proposés en cas de force majeur
                                    (panne, intervention technique de maintenance). La
                                    responsabilité du Service central des armes ne pourrait être
                                    engagée.
                                </p>
                                <p>
                                    Le Site est optimisé pour Firefox 4 et plus, Internet Explorer
                                    version 8 et 9, Safari 5.1 et plus, Chrome 5.0.
                                </p>
                            </div>
                        </div>
                    </ModalV2Content>
                </ModalV2>
            ) : null}
        </>
    );
};

ModaleCgu.propTypes = {
    fermerModale: PropTypes.func.isRequired,
    modaleOuverte: PropTypes.bool,
};

ModaleCgu.defaultProps = {
    modaleOuverte: false,
};

export default ModaleCgu;
